import { useState, useEffect, useRef } from "react";
import { BlobServiceClient } from "@azure/storage-blob";
import "./registeredStartTest.css";
import outlineSvg from "../profile/otherSkills/images/outline.svg";
import fillSvg from "../profile/otherSkills/images/fill.svg";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import CircularProgress from "@mui/material/CircularProgress";
import { useLocation, useNavigate } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import createB2cMapping from "../../apis/b2cMapping/createB2cMapping";
import createProfile from "../../apis/profile/createProfile";
import createMySkill from "../../apis/skills/createMyskill";
import userTestFeedback from "../../apis/userTest/userTestFeedback";
import getSkillBySkillId from "../../apis/skills/getSkillBySkillId";
import createUserTestRequest from "../../apis/userTest/createUserTest";
import createUserRequest from "../../apis/users/createUser";
import getUserTestQuestionAnswer from "../../apis/userTest/userTestQuestionAnswerByTestId";
import putUserTestQuestionAnswerResponse from "../../apis/userTest/putUserTestQuestionAnswerByTestId";
import sendEmailResponse from "../../apis/email/sendEmail";
import updateAbortedTest from "../../apis/userTest/updateAbortedTest";
import updateTestTakenResponse from "../../apis/userTest/updateTestTaken";
import testQuestionDescription from "../../utilities/questionSyntaxHighlight";
// import Prism from "prismjs";
import insertIntoMyCandidate from "../../apis/userTest/insertCandidateInMyCandidate";
import postUserTestQuestionResponse from "../../apis/userTest/postUserTestQuestion";
import getAllMailforRecruiterResponse from "../../apis/recruiters/getAllMailForRecruiter";
import emailConfigurationByCodeResponse from "../../apis/email/emailConfigurationByCode";
import generateUserCredentials from "../../apis/users/generateUserCredentials";
import additionalTestDetails from "../../apis/userTest/additionalTestDetails";
import getAllReferralSkiilsByRecruiterPartners from "../../apis/referral/referralbyrecruitmentpartner";
import Draggable from "react-draggable";
import recruiter_header_logo from "../../components/basicInfoForm/images/logo_recruiter_header.png";
import getAllQuestionDetailsDynamic from '../../apis/userTest/getAllQuestionDetailsDynamic'
import NextIcon from "../../components/basicInfoForm/images/nextIcon.svg";
import insertIntoCandidateResumeMappingPowerResume from "../../apis/candidateResume/insertIntoCandidateResumeMappingPowerResume";
import createCandidateProfileAtSelfTest from "../../apis/candidateResume/createCandidateProfileAtSelfTest";

import "./style_RgTest.css";
import putUserTestDetails from "../../apis/userTest/putUserTestDetails";
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import recruiter_sign_thankyou_icon from "../../components/basicInfoForm/images/successBlueTick.png";
import Mic from '@mui/icons-material/Mic';
import Videocam from '@mui/icons-material/Videocam';
import myCandidate from "../../apis/recruiters/myCandidate";
import { getCountryFromIp } from "../../utilities/getCountryFromIp";
import { ThankYouContent } from "../thankyoucontent/thankyoucontent";
import "../../pages/thankyoupage/thankyoupage.css";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const stylesSX = {
  buttonAlignForRemove: {
    padding: '32px !important',
  },
  bodyForRemove: {
    padding: '26px 24px 0px 24px !important',
    marginTop: '0px !important',
  },
  LinearProgress: {
    height: '18px',
    width: '260px',
    backgroundColor: 'transparent',
    border: '0.5px solid #0397DA',
    borderRadius: '10px',
    zIndex: 2,
    position: 'absolute',
    opacity: 0.8,
  },
  LinearProgress1: {
    height: '18px',
    width: '260px',
    backgroundColor: 'transparent',
    border: '0.5px solid #0397DA',
    borderRadius: '10px',
    position: 'absolute',
    opacity: 0.8,
    zIndex: 1,
  },
  progrssLabel_ans: {
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: '#0397DA',
    letterSpacing: '1px',
  },
  progrssLabel_viewed: {
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    color: '#0397DA',
    letterSpacing: '1px',
    opacity: 0.8,
  },
  progrssLabel_total: {
    fontFamily: 'Manrope-Regular',
    fontSize: '14px',
    letterSpacing: '1px',
    opacity: 0.6,
  },
  testQuestAnsCard: {
    margin: '0 11%',
    marginTop: '10px',
    height: '66vh',
    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
  },
  rightDiv: {
    paddingLeft: '30px',
    paddingRight: '20px',
  },
  nextQ: {
    fontFamily: 'Manrope-Semibold',
    fontSize: '26px',
    color: '#1885E6',
    marginTop: '-5px',
  },
  topVideo: {
    height: '90%',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  grdidContentCenter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  absoluteGrid: {
    position: 'absolute',
  },
  progressGap: {
    marginTop: '20px',
  },
  cardAfterQuestion: {
    margin: '0 5%',
    marginTop: '120px',
    minHeight: '66vh',
    marginBottom: '15px',
    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
  },
};

const RegisteredStartTest = (props) => {
  const location = useLocation();

  const pageName = location.state?.pageName;
  const recruiterPartnerId = location?.state?.recruitmentpartnerId;
  const jsonConfig = require("../../Config.json");
  const history = useNavigate();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [radioButtonChecked, setRadioButtonChecked] = useState(null);
  const [preInvterviewState, setPreInterviewState] = useState(true);
  const processAnime = false;
  const [cheatAlert, setCheatAlert] = useState(false);
  const [postInterviewState, setPostInterviewState] = useState(false);
  const [questionTimer, setQuestionTimer] = useState(5);
  const [userQuestions, setUserQuestions] = useState([]);
  const [skillSets, setSkillSets] = useState("");
  const [timerOn, setTimerOn] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [testOnGoing, setTestOnGoing] = useState(false);
  const [testOnGoingModal, setTestOnGoingModal] = useState(false);
  const userCameraPermissionRef = useRef(false);
  const videoRef = useRef(null);
  const userCameraStreamRef = useRef(null);
  const streamRecorderRef = useRef(null);
  const currentQuestionIndexRef = useRef(0);
  const isTestCompletedRef = useRef(false);
  const currentTimeoutIdRef = useRef(null);
  const userTestIdRef = useRef("");
  const userIdRef = useRef("");
  const sessionLogsRef = useRef([]);
  const sessionStartTimeRef = useRef(null);
  const hiddenIntervalRef = useRef(null);
  const currentViolationIdRef = useRef(null);
  const userQuestionsRef = useRef([]);
  const startGivingTestRef = useRef(false);
  const userAnswersResponseRef = useRef({});
  const uploadedQuestionCounterRef = useRef(0);
  const cheatCounter = useRef(0);
  const [star, setStar] = useState("");
  const [comment, setComment] = useState("");
  const [starToggle, setStarToggle] = useState(true);
  const [isreviewSubmited, setisreviewSubmited] = useState(false);
  const [isEmailSend, setisEmailSend] = useState(false);
  const [finishStatus, setfinishStatus] = useState(false);
  const [referralProgram, setReferralProgram] = useState("");
  const [candidateResumeIds, setCandidateResumeIds] = useState("");
  const questionTimeCounterRef = useRef({
    startTime: null,
    elapsedTime: 0,
  })
  const goToTestQuestionsCalledRef = useRef(false);


  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (!finishStatus) {
      if (
        window.confirm(
          "Exiting during a test will be recorded & retesting will not be allowed. Would you like to exit?"
        )
      ) {
        var testId = userTestIdRef.current;
        var payload = {
          isAborted: true,
        };
        try {
          updateAbortedTest(testId, payload);
          updateTestTaken(
            location.state.pageName.replace("/invite/", ""),
            false
          );
          setTestOnGoing(false);
          userAnswerSave();
          stopRecording();
          clearTimeout(currentTimeoutIdRef.current);
          userCameraStreamRef.current
            .getTracks()
            .forEach((track) => track.stop());
          setPostInterviewState(true);
          getUserTestDetails();
          setfinishStatus(true);
        } catch (error) {
          if (localStorage.getItem("token")) {
            window.location.pathname = "/landing";
          }
        }
      } else {
        window.history.pushState(null, null, window.location.pathname);
        setfinishStatus(false);
      }
    }
  };
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);

  const onUnload = (event) => {
    event.returnValue = " Are you sure you want to exit?";
  };

  const createUserData = async () => {
    if (!location.state.userId) {
      const userDataRequest = {
        roleId: jsonConfig.candidateRoleId,
        firstName: location.state.firstName,
        lastName: location.state.lastName,
        MiddleInitial: location.state.MiddleInitial,
        phoneNumber: location.state.phoneNumber,
        countryCode: location.state.countryCode,
        email: location.state.email,
        password: location.state.password,
        createdBy: "NewUser",
        updatedBy: "NewUser",
        isActive: true,
      };

      try {
        const createUser = await createUserRequest(userDataRequest);


        const user_id = createUser?.data?.data?.id;
        userIdRef.current = createUser.data?.data?.id;
        if (userIdRef.current) {
          await b2cMapping(createUser.data?.data?.id);
          await profileCreated(createUser.data?.data?.id);
          await AddPrimarySkill(createUser.data?.data?.id);
          sendUserEmail(createUser.data?.data?.id)
          if (!pageName) {
            //first time self test
            await insertIntoMyCandidate(createUser.data?.data?.id);
            const candidateResumePayload = {
              powerResumeId: createUser.data?.data?.id,
              email: createUser.data?.data?.email,
              recruitmentpartnerId: null,
              uploadedType: "Candidate Upload",
              uploadedBy: createUser.data?.data?.id,
              isReferred: 0,
              skillId: location.state.skillId,
              testType: "self"
            }
            let candidateResumeResponse = await insertIntoCandidateResumeMappingPowerResume(candidateResumePayload)
            setCandidateResumeIds(candidateResumeResponse.data)
          }
          else {
            const inviteId = location?.state?.inviteId
            const recruiterId = location?.state?.recruiterId
            if (inviteId && recruiterId) {
              //first time invidetest
              await MyCandidatePost(inviteId, true, user_id);
              let profileId = user_id ? user_id : location?.state?.userId;
              const candidateResumePayload = {
                powerResumeId: profileId,
                email: "",
                recruitmentpartnerId: location?.state?.recruitmentpartnerId,
                uploadedType: "Recruiter Upload",
                uploadedBy: location?.state?.recruiterId,
                isReferred: 0,
                skillId: location.state.skillId,
                testType: "invited"
              }
              let candidateResumeResponse = await insertIntoCandidateResumeMappingPowerResume(candidateResumePayload)
              setCandidateResumeIds(candidateResumeResponse.data)
            }

          }
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      //poweResume all ready created
      userIdRef.current = location.state.userId;
      let questionResponse = await getSkillTestQuestions(location.state.allTestId);
      const inviteId = location?.state?.inviteId
      const recruiterId = location?.state?.recruiterId
      let is_invited_by_recruiter = false;
      let profileId = location?.state?.userId;
      if (inviteId && recruiterId) {
        await MyCandidatePost(inviteId, true);
        is_invited_by_recruiter = true;
      }
      if (questionResponse.data.message) {
        if (userCameraStreamRef.current) {
          await userCameraStreamRef.current.getTracks().forEach((track) => {
            track.stop();
            if (localStorage.getItem("token")) {
              window.location.pathname = "/landing";
            } else {
              history("/");
            }
          });
        }
        return NotificationManager.error(
          "Question Bank For This Skill Is Being Updated – Please Try Later",
          "Error",
          10000
        );
      } else {

        await createUserTest(
          location.state.userId,
          location.state.test.skillId,
          location.state.test.id

        );
        await postUserInitialAnswerResponse(location.state.userId);
        if (is_invited_by_recruiter) {
          const candidateResumePayload = {
            powerResumeId: profileId,
            email: "",
            recruitmentpartnerId: location?.state?.recruitmentpartnerId,
            uploadedType: "Recruiter Upload",
            uploadedBy: location?.state?.recruiterId,
            isReferred: 0,
            skillId: location.state.skillId,
            testType: "invited",
          }
          let candidateResumeResponse = await insertIntoCandidateResumeMappingPowerResume(candidateResumePayload)
          setCandidateResumeIds(candidateResumeResponse.data)
        } else {
          const candidateResumePayload = {
            powerResumeId: profileId,
            email: location?.state?.email,
            uploadedType: "Candidate Upload",
            uploadedBy: profileId,
            isReferred: 0,
            testType: "self",
          }
          let candidateResumeResponse = await createCandidateProfileAtSelfTest(candidateResumePayload)
          setCandidateResumeIds(candidateResumeResponse.data)
        }
        setIsDataLoaded(true);
      }
    }
  };

  const b2cMapping = async (id) => {
    const b2cMappingPayload = {
      email: location.state.email,
      b2cid: null,
      userid: id,
      isCreated: false,
      createdBy: id,
      updatedBy: id,
    };
    try {
      await createB2cMapping(b2cMappingPayload);
    } catch (err) {
      console.log(err);
    }
  };

  const profileCreated = async (id) => {
    const profileCreatedPayload = {
      id: id,
      locationCountry: location.state.locationCountry,
      locationState: location.state.locationState,
      locationCity: location.state.locationCity,
      b2cId: null,
      createdBy: id,
      updatedBy: id,
    };
    try {
      await createProfile(profileCreatedPayload);
    } catch (err) {
      console.log(err);
    }
  };
  const AddPrimarySkill = async (id) => {
    const skillData = {
      skillId: location.state.skillId,
      profileId: id,
      isPrimary: true,
      createdBy: id,
      updatedBy: id,
      subSkillsJson: location.state.subSkillsJson,
    };

    try {
      const primarySkillResponse = await createMySkill(skillData);
      await createUserTest(
        id,
        primarySkillResponse.data.data.skillId,
        location.state.test.id
      );
      await getSkillTestQuestions(location.state.allTestId);
      await postUserInitialAnswerResponse(id);

      await skillSet(primarySkillResponse.data.data.skillId);
      setIsDataLoaded(true);
    } catch (error) {
      console.log(error);
    }
  };

  const fnstarRatingCaluculation = () => {
    const starArr = [
      outlineSvg,
      outlineSvg,
      outlineSvg,
      outlineSvg,
      outlineSvg,
    ];
    setStar(starArr);
  };
  const [starRating, setstarRating] = useState(0);
  const starClicked = (clickIndex) => {
    setStarToggle((prev) => !prev);
    const starArr = [
      outlineSvg,
      outlineSvg,
      outlineSvg,
      outlineSvg,
      outlineSvg,
    ];
    if (starToggle && clickIndex) {
      const arr = starArr.fill(fillSvg, 0, clickIndex + 1);
      setStar(arr);
      setstarRating(clickIndex + 1);
    } else {
      const arr = starArr.fill(fillSvg, 0, clickIndex + 1);
      setStar(arr);
      setstarRating(clickIndex + 1);
    }
  };
  const reviewSubmit = async () => {
    if (starRating === 0 || starRating === null) {
      NotificationManager.error("Select a rating", "Error", 10000);
      return;
    }

    const reviewSubmitPayLoad = {
      candidateTestRating: starRating,
      candidateComment: comment,
    };
    try {
      await userTestFeedback(
        userTestIdRef.current,
        reviewSubmitPayLoad
      );
      setisreviewSubmited(true);
      
      // Redirect after 1.5 seconds
      setTimeout(() => {
        if (recruiterPartnerId !== undefined && recruiterPartnerId !== null) {
          if (referralProgram[0]?.isActive === true || referralProgram.length === 0) {
            goToReferralPage();
          }
        } else {
          goToProfilePage();
        }
      }, 1500);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fnstarRatingCaluculation();
    // Show alert on close tab / browser
    window.addEventListener("beforeunload", onUnload);

    //cleanup event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", onUnload);
    };
  }, []);


  // Go To Start Questions
  const goToTestQuestions = async () => {
    await initializeUserCamera();

    await initializeUserCameraRecorder();
    if (userCameraPermissionRef.current) {
      await createUserData();
      if (streamRecorderRef.current) {
        startRecording();
        firstQuestionStart();
      }
    } else {
      if (!location.state.userId) {
        var redirectPageName = !location.state.pageName
          ? "/test-landing"
          : location.state.pageName;
        history(redirectPageName,
          {
            state: {
              ...location.state,
              text: `Please click on the lock icon at the top left of the browser's address bar and allow permissions for camera and microphone.
          `,
            },
          });
      } else {
        history("/profile",
          {
            state: {
              ...location.state,
              text: `Please click on the lock icon at the top left of the browser's address bar and allow permissions for camera and microphone.
          `,
            },
          });
      }

      return NotificationManager.error(
        "This test cannot be taken without activating camera and microphone. Please allow camera and microphone access.",
        "Error",
        10000
      );
    }
  };

  const skillSet = async (skillid) => {
    const skillSet = await getSkillBySkillId(skillid);
    setSkillSets(skillSet.data.data[0]);
  };

  // Start video recording
  const startRecording = () => {
    if (userQuestionsRef.current.length > 0) {
      const streamRecorder = streamRecorderRef.current;
      if (streamRecorder && streamRecorder.state === "inactive") {
        streamRecorder.start();
      }
    }
  };

  // Stop video recording
  const stopRecording = () => {
    if (userQuestions.length > 0) {
      const streamRecorder = streamRecorderRef.current;
      if (streamRecorder && streamRecorder.state === "recording") {
        streamRecorder.stop();
      }
    }
  };

  // Initialize user camera
  const initializeUserCamera = async () => {
    if (!userCameraStreamRef.current) {
      const getWebcamStream = async () => {
        const webcamStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
        userCameraStreamRef.current = webcamStream;
        if (
          webcamStream.getVideoTracks().length > 0 &&
          webcamStream.getAudioTracks().length > 0
        ) {
          userCameraPermissionRef.current = true;
        } else {
          console.error("Failed to get video or audio tracks");
        }
      };
      try {
        await getWebcamStream();
      } catch (error) {
        console.error("Error accessing camera:", error);
        userCameraPermissionRef.current = false;
      }
    }
  };

  // Initialize user camera recorder
  const initializeUserCameraRecorder = async () => {
    if (userCameraStreamRef.current) {
      const options = {
        audioBitsPerSecond: 64000,
        videoBitsPerSecond: 500000,
        mimeType: "video/webm; codecs=vp8,opus",
      };
      if (!streamRecorderRef.current) {
        streamRecorderRef.current = new MediaRecorder(
          userCameraStreamRef.current,
          options
        );
        if (streamRecorderRef.current) {
          streamRecorderRef.current.onerror = function (event) {
            console.error(event);
          };
          streamRecorderRef.current.ondataavailable = async function (event) {
            const tempQuestionIndex = uploadedQuestionCounterRef.current;
            uploadedQuestionCounterRef.current =
              uploadedQuestionCounterRef.current + 1;
            if (userAnswersResponseRef.current.question[tempQuestionIndex]) {
              await uploadVideoToBlobStorage(
                event.data,
                userAnswersResponseRef.current.question[tempQuestionIndex]
                  .questionid,
              );
            }

          };
        }
      }
    }
  };

  // Upload video to storage
  const uploadVideoToBlobStorage = async (
    videoBlob,
    questionId
  ) => {
    const sas = jsonConfig.sasToken;
    const bsClient = new BlobServiceClient(
      `${jsonConfig.ctResourcesCdn + sas}`
    );
    const containerClient = await bsClient.getContainerClient(
      "videointerviewsession"
    );
    const blobName =
      userIdRef.current +
      "/" +
      userTestIdRef.current +
      "/" +
      questionId +
      ".webm";
    const blobClient = await containerClient.getBlockBlobClient(blobName);
    await blobClient.uploadBrowserData(videoBlob, {
      blobHTTPHeaders: {
        blobContentType: "video/webm",
      },
    });
  };

  // User answer handler
  const onRadioChange = (e) => {
    let userOption = e.target.value;
    userAnswersResponseRef.current.question[
      currentQuestionIndexRef.current
    ].answers = [];
    userAnswersResponseRef.current.question[
      currentQuestionIndexRef.current
    ].answers.push({
      answer: userOption,
      submittedData: "",
    });
    setRadioButtonChecked(e.target.value);
  };

  // Set question timer
  const addQuestionTimeout = () => {
    setTimerOn(true);
    setUserQuestions(userQuestionsRef.current);
    const timeLimit =
      userQuestionsRef.current[currentQuestionIndexRef.current]?.timeLimit;
    const tempTimeLimit = +timeLimit;
    const actualTimeLimit = tempTimeLimit * 1000;
    setQuestionTimer(actualTimeLimit);

    questionTimeCounterRef.current.startTime = Date.now();
    questionTimeCounterRef.current.elapsedTime = 0;

    if (currentTimeoutIdRef.current) {
      clearTimeout(currentTimeoutIdRef.current);
    }
    currentTimeoutIdRef.current = setTimeout(() => {
      const nextButton = document.getElementById("toggle-question");
      if (nextButton) {
        nextButton.click();
      }
    }, actualTimeLimit);
  };
  // minute second calculation
  const millisToMinutesAndSeconds = (millis) => {
    let minutes = Math.floor(millis / 60000);
    let seconds = ((millis % 60000) / 1000).toFixed(0);
    return (
      (minutes < 10 ? "0" : "") +
      minutes +
      ":" +
      (seconds < 10 ? "0" : "") +
      seconds
    );
  };

  useEffect(() => {
    let interval = null;
    if (timerOn) {
      interval = setInterval(() => {
        setQuestionTimer((prevTime) => {
          const newTime = prevTime - 1000;
          if (questionTimeCounterRef.current.startTime) {
            questionTimeCounterRef.current.elapsedTime = Math.floor(
              (Date.now() - questionTimeCounterRef.current.startTime) / 1000
            );
          }
          return newTime;
        });
      }, 1000);
    } else if (!timerOn) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timerOn]);

  const getReferralProgramDetails = async () => {
    try {
      const res = await getAllReferralSkiilsByRecruiterPartners(
        recruiterPartnerId
      );
      setReferralProgram(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!goToTestQuestionsCalledRef.current) {
      goToTestQuestionsCalledRef.current = true;
      if (location.state) {

        goToTestQuestions();
        getReferralProgramDetails();
      }
      else {
        NotificationManager.error("Unauthorized Access", "Error", 10000);
        history("/");
      }
    }
  }, []);

  // Start first question
  const firstQuestionStart = () => {
    setUserQuestions(userQuestionsRef.current);
    startGivingTestRef.current = true;
    setPreInterviewState(false);
    if (videoRef.current && userCameraStreamRef.current) {
      if (videoRef.current.srcObject !== userCameraStreamRef.current) {
        videoRef.current.srcObject = userCameraStreamRef.current;
      }
      videoRef.current.play().catch((error) => {
        console.error("Error playing video:", error);
        // Try to play again after a short delay
        setTimeout(() => {
          if (videoRef.current) {
            videoRef.current.play().catch(console.error);
          }
        }, 100);
      });
      videoRef.current.volume = 0;
    }
    addQuestionTimeout();
  };

  // Question handler
  const goToNextQuestion = async (e) => {
    setTimerOn(true);

    const actualTimeSpent = questionTimeCounterRef.current.startTime
      ? Math.floor((Date.now() - questionTimeCounterRef.current.startTime) / 1000)
      : questionTimeCounterRef.current.elapsedTime;

    // Update the answer with accurate time

    if (userAnswersResponseRef.current.question[
      currentQuestionIndexRef.current
    ]) {
      userAnswersResponseRef.current.question[
        currentQuestionIndexRef.current
      ].userTimeTaken = actualTimeSpent.toString();
      userAnswersResponseRef.current.question[
        currentQuestionIndexRef.current
      ].questionNumber = currentQuestionIndexRef.current + 1;
    }

    setRadioButtonChecked(null);
    // answer-checks
    let inputCheckboxes = document.querySelectorAll(".answer-checks");
    for (let i = 0; i < inputCheckboxes.length; i++) {
      inputCheckboxes[i].checked = false;
    }
    if (
      currentQuestionIndexRef.current + 1 ===
      userQuestionsRef.current.length
    ) {
      isTestCompletedRef.current = true;
      setTestOnGoing(false);
      userAnswerSubmit();
      stopRecording();
      clearTimeout(currentTimeoutIdRef.current);
      userCameraStreamRef.current.getTracks().forEach((track) => track.stop());
      setPostInterviewState(true);

    } else {
      userAnswerSave();
      stopRecording();
      currentQuestionIndexRef.current = currentQuestionIndex + 1;
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      addQuestionTimeout();
      startRecording();
    }
  };

  const goToProfilePage = async (e) => {
    if (testOnGoing) {
      await onBackButtonEvent(e);
    } else {
      history("/");
    }
  };
  const stopAndGoProfile = async () => {
    await userCameraStreamRef.current
      .getTracks()
      .forEach((track) => track.stop());
    if (localStorage.getItem("token")) {
      window.location.pathname = "/landing";
    } else {
      history("/");
    }
  };

  // Start Skill Test Server
  const getSkillTestQuestions = async (allTestIds) => {

    const skillTestResponse = await getAllQuestionDetailsDynamic(allTestIds);

    if (skillTestResponse.data.data) {
      setUserQuestions([...skillTestResponse.data.data]);
      userQuestionsRef.current = skillTestResponse.data.data;
    }

    return skillTestResponse;
  };

  // Create User Test
  const createUserTest = async (userId, skillId, testId) => {
    let country = await getCountryFromIp()
    let payload = {
      user: userId,
      industry: jsonConfig.userIndustryId,
      skill: skillId,
      isVideoAvailable: true,
      createdBy: userId,
      testId: testId,
      assessmentCountryCode: country,
    };
    const createTestResponse = await createUserTestRequest(payload);
    setTestOnGoing(true);
    userTestIdRef.current = createTestResponse.data.data.id;
  };

  // Post User Response
  const postUserInitialAnswerResponse = async (userId) => {
    let tempUserQuestion = [];
    tempUserQuestion = userQuestionsRef.current;
    const questionTempArr = [];
    tempUserQuestion.forEach((el, index) => {
      const tempObjData = {
        questionid: el.id,
        userTimeTaken: "0",
        questionNumber: index + 1,
        videoURL:
          `${jsonConfig.ctResourcesCdn}/videointerviewsession/` +
          userId +
          "/" +
          userTestIdRef.current +
          "/" +
          tempUserQuestion[index].id +
          ".webm",
        createdBy: el.createdBy,
        updatedBy: el.updatedBy,
        answers: [],
      };
      questionTempArr.push(tempObjData);
    });
    const tempResponseData = {
      usertest: userTestIdRef.current,
      updatedBy: userId,
      question: questionTempArr,
      isCompleted: false,
    };
    userAnswersResponseRef.current = tempResponseData;
    const userInitialResponseLocal = await postUserTestQuestionResponse(
      tempResponseData
    );
    const postUserQuestionTempResponse = userInitialResponseLocal.data.data;
    postUserQuestionTempResponse.forEach((el, index) => {
      userAnswersResponseRef.current.question[index].id = el.id;
    });
  };

  // On change textbox
  const handleCheckbox = (event, answerId) => {
    if (event.target.checked === true) {
      userAnswersResponseRef.current.question[
        currentQuestionIndexRef.current
      ].answers.push({
        answer: answerId,
        submittedData: "",
      });
    } else {
      var uncheckedArrElemIndex = -1;
      for (let i = 0; i < userAnswersResponseRef.current.question[currentQuestionIndexRef.current].answers.length; i++) {
        if (userAnswersResponseRef.current.question[currentQuestionIndexRef.current].answers[i].answer === answerId &&
          userAnswersResponseRef.current.question[currentQuestionIndexRef.current].answers[i].submittedData === "") {
          uncheckedArrElemIndex = i;
          break;
        }
      }
      if (uncheckedArrElemIndex > -1) {
        userAnswersResponseRef.current.question[
          currentQuestionIndexRef.current
        ].answers.splice(uncheckedArrElemIndex, 1);
      }
    }
  };

  // Put user testtoken
  const updateTestTaken = async (invitedId, payloadVal) => {
    var payload = {
      testTaken: payloadVal,
    };
    try {
      await updateTestTakenResponse(invitedId, payload);
    }
    catch (e) {
      console.log(e);
    }
  };

  const MyCandidatePost = async (invitedId, payloadVal, user_Id) => {
    var payload = {
      candidateid: user_Id ? user_Id : location?.state?.userId,
      recruiterid: location?.state?.recruiterId,
      recruitmentpartnerId: location?.state?.recruitmentpartnerId
    }
    try {
      await myCandidate(payload);
    } catch (error) {
      console.log(error);
    }
  }



  // Put user answer save
  const userAnswerSave = async () => {
    let result = await putUserTestQuestionAnswerResponse(
      userTestIdRef.current,
      userAnswersResponseRef.current
    );
    if (result.status === 201) {
      const inviteId = location?.state?.inviteId
      const recruiterId = location?.state?.recruiterId;
      let isInvited = false;
      if (inviteId && recruiterId) {
        isInvited = true;
      }

      await putUserTestDetails(
        userTestIdRef.current,
        userAnswersResponseRef.current,
        result.data.data,
        isInvited,
        candidateResumeIds
      )
    }

  };

  // Submit user answer save
  const userAnswerSubmit = async () => {
    userAnswersResponseRef.current.isCompleted = true;

    let result = await putUserTestQuestionAnswerResponse(
      userTestIdRef.current,
      userAnswersResponseRef.current
    );

    await getUserTestDetails();


    const inviteId = location?.state?.inviteId
    let isInvited = false;
    if (inviteId) {
      await updateTestTaken(inviteId, true);
      isInvited = true;
    }
    if (result.status === 201) {

      await putUserTestDetails(
        userTestIdRef.current,
        userAnswersResponseRef.current,
        result.data.data,
        isInvited,
        candidateResumeIds
      )
    }
  };
  // get user test detail
  const getUserTestDetails = async () => {
    try {
      const userTestDetails = await getUserTestQuestionAnswer(
        userTestIdRef.current
      );
      const tempUsersTestDetails = userTestDetails.data.data;
      let userTestScore = 0;
      tempUsersTestDetails.forEach((el) => {
        if (el.isCorrect) {
          userTestScore = userTestScore + 1;
        }
      });
      await getAllMailforRecruiter(userTestScore, tempUsersTestDetails.length);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllMailforRecruiter = async (userTestScore, noOfQuestion) => {
    let skillTestEmails = [];
    try {
      var getByCodeandCountryData = {
        code: "RecruitmentTeam",
        country: location.state.locationCountry? JSON.parse(location.state.locationCountry).name: "",
      };
      const response = await getAllMailforRecruiterResponse(
        getByCodeandCountryData
      );
      response.data.data[0].emails.forEach(function (emailId) {
        skillTestEmails.push(emailId);
      });
    } catch (error) {
      console.log(error);
    }
    try {
      var codeForMail = {
        code: "CTTestResultEmail",
      };
      const getTestResultEmail = await emailConfigurationByCodeResponse(
        codeForMail
      );
      getTestResultEmail.data.data[0].emails.forEach(function (emailId) {
        skillTestEmails.push(emailId);
      });
    } catch (error) {
      console.log(error);
    }
    await recruiterEmail(skillTestEmails, userTestScore, noOfQuestion);
  };

  // user email after test

  const sendUserEmail = async (userId) => {
    const data = {
      userid: userId,
    };
    if (jsonConfig.sendEmail) {
      try {
        await generateUserCredentials(data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // email that will send to recruiter
  const recruiterEmail = async (
    allrecruiterEmail,
    userTestScore,
    noOfQuestion
  ) => {
    if (!location.state.userId) {
      if (jsonConfig.sendEmail) {
        const message = {
          to: allrecruiterEmail,
          from: jsonConfig.sendGridFromEmail,
          subject:
            "Skill Test on " +
            location.state.test.testName +
            " completed by " +
            location.state.firstName +
            " " +
            location.state.lastName +
            ", " +
            JSON.parse(location.state.locationCountry).name,
          html: `<p>Email: ${location.state.email}</p><p>Test: ${location.state.test.testName
            }</p><p>Skill: ${skillSets.name}</p><p>Location: ${location.state.locationCity
              ? JSON.parse(location.state.locationCity).name
                ? JSON.parse(location.state.locationCity).name + ","
                : ""
              : ""
            } 
            ${location.state.locationState
              ? JSON.parse(location.state.locationState).name + ","
              : ""
            } 
            ${JSON.parse(location.state.locationCountry).name
            }</p><p>Test Score: ${userTestScore}/${noOfQuestion}
            </p>The Skill Test Link is: <a href="https://${window.location.host
            }/test/${userTestIdRef.current}" >https://${window.location.host
            }/test/${userTestIdRef.current} <a/>
        `,
        };
        await sendEmailResponse(message);
        setisEmailSend(true);
      }
    } else {
      setisEmailSend(true);
    }
  };

  const handleCheatClose = () => {
    setCheatAlert(false);
  };

  // Handle question card index
  useEffect(() => {
    currentQuestionIndexRef.current = currentQuestionIndex;
  }, [currentQuestionIndex]);

  // To Set Questions Use Effect
  useEffect(() => {
    setUserQuestions(userQuestionsRef.current);
  }, []);

  // Set up video element when camera stream is available
  useEffect(() => {
    if (videoRef.current && userCameraStreamRef.current && !preInvterviewState && !postInterviewState) {
      if (videoRef.current.srcObject !== userCameraStreamRef.current) {
        videoRef.current.srcObject = userCameraStreamRef.current;
        videoRef.current.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }
    }
  }, [preInvterviewState, postInterviewState]);

  const lastLoggedIndexRef = useRef(null);  // Track last logged index

  useEffect(() => {

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Tab hidden - start violation tracking
        sessionStartTimeRef.current = Date.now();
        currentViolationIdRef.current = Date.now().toString();
        lastLoggedIndexRef.current = currentQuestionIndexRef.current;

        hiddenIntervalRef.current = setInterval(() => {
          const newIndex = currentQuestionIndexRef.current;

          if (newIndex !== lastLoggedIndexRef.current) {
            handleQuestionChange(lastLoggedIndexRef.current, newIndex);
          }

          if (isTestCompletedRef.current) {
            handleTestCompletion();
          }
        }, 1000);
      } else {
        // Tab visible - stop tracking
        if (hiddenIntervalRef.current) {
          handleReturnToTab();
        }
      }
    };

    const handleQuestionChange = async (prevIndex, newIndex) => {
      if (prevIndex === null || newIndex === null) return;

      const elapsed = Math.floor((Date.now() - sessionStartTimeRef.current) / 1000);
      const questionTimeLimit = userQuestionsRef.current[prevIndex]?.timeLimit || Infinity;
      const cappedTime = Math.min(elapsed, questionTimeLimit);

      if (cappedTime > 0 && !sessionLogsRef.current.some(log => log.index === prevIndex)) {
        sessionLogsRef.current.push({ index: prevIndex, timeSpent: cappedTime });

        // **Increment the violation counter**
        cheatCounter.current += 1;

        const userTestQuestionId = userAnswersResponseRef?.current?.question?.filter((e => e.questionid === userQuestionsRef.current[prevIndex]?.id))

        const payload = {
          userId: userTestIdRef.current,
          data: {
            userId: userIdRef?.current,
            NumberofViolations: cheatCounter.current,  // ✅ Now updates correctly
            violationType: "Tab Switched",
            violationTime: cappedTime,
            userTestQuestionId: userTestQuestionId[0]?.id,
            testId: userTestIdRef?.current
          },
        };

        try {
          if (!isTestCompletedRef.current) {
            await additionalTestDetails(payload);
            NotificationManager.error(
              "Violation Detected and Reported",
              "Error",
              10000
            )
          }

        } catch (error) {
          console.error(`Error sending data for question ${prevIndex}:`, error);
        }
      }

      // Reset session tracking
      sessionStartTimeRef.current = Date.now();
      lastLoggedIndexRef.current = newIndex;
    };

    const handleTestCompletion = async () => {
      clearInterval(hiddenIntervalRef.current);
      hiddenIntervalRef.current = null;

      const elapsed = Math.floor((Date.now() - sessionStartTimeRef.current) / 1000);
      const currentIndex = lastLoggedIndexRef.current;

      if (currentIndex !== null && elapsed > 0) {
        const questionTimeLimit = userQuestionsRef.current[currentIndex]?.timeLimit || Infinity;
        const cappedTime = Math.min(elapsed, questionTimeLimit);

        cheatCounter.current += 1;  // ✅ Ensure violation count updates
        const userTestQuestionId = userAnswersResponseRef?.current?.question?.filter((e => e.questionId === userQuestionsRef.current[currentIndex]?.id))

        const payload = {
          userId: userTestIdRef.current,
          data: {
            userId: userIdRef?.current,
            NumberofViolations: cheatCounter.current,  // ✅ Now updates correctly
            violationType: "Tab Switched",
            violationTime: cappedTime,
            userTestQuestionId: userTestQuestionId[0]?.id,
            testId: userTestIdRef?.current
          },
        };

        try {
          if (!isTestCompletedRef.current) {
            await additionalTestDetails(payload);
            NotificationManager.error(
              "Violation Detected and Reported",
              "Error",
              10000
            )
          }
        } catch (error) {
          console.error("Error sending final question violation data:", error);
        }
      }

      // Reset everything
      sessionStartTimeRef.current = null;
      lastLoggedIndexRef.current = null;
      currentViolationIdRef.current = null;
      sessionLogsRef.current = [];
    };

    const handleReturnToTab = async () => {
      clearInterval(hiddenIntervalRef.current);
      hiddenIntervalRef.current = null;

      const elapsed = Math.floor((Date.now() - sessionStartTimeRef.current) / 1000);
      const currentIndex = lastLoggedIndexRef.current;

      if (currentIndex !== null && elapsed > 0) {
        handleQuestionChange(currentIndex, currentIndex);
      }

      sessionStartTimeRef.current = null;
      lastLoggedIndexRef.current = null;
      currentViolationIdRef.current = null;
      sessionLogsRef.current = [];
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (hiddenIntervalRef.current) {
        clearInterval(hiddenIntervalRef.current);
      }
    };
  }, []);

  // setTimeout(() => Prism.highlightAll(), 0);


  window.onload = async function () {
    window.open("/", "_self");
  };
  const goToReferralPage = () => {
    if (referralProgram.length === 0 && recruiterPartnerId !== undefined) {
      history("/referral");
    } else {
      history("/referral",
        {
          state: {
            recruiterPartnerId,
          },
        });
    }
  };
  return (
    <>
      <div className="mainContainer_Test">
        <div className="nav_bg_home home-specific-header">
          <div className="container w1200 nav_bg_home_section">
            <div className="nav_bg_left">
              <li className="cp headerListStyleNone">
                <span>
                  <img
                    src={recruiter_header_logo}
                    className="nav_logo_home"
                    alt="img"
                    onClick={(e) => goToProfilePage(e)}
                  />
                </span>
              </li>
            </div>
          </div>
        </div>
        <div className="nav_bg_home_responsive">
          <div className="nav_bg_home_responsive-wrapper">
            <div className="home-top-nav">
              <li className="cp headerListStyleNone">
                <span>
                  <img
                    src={recruiter_header_logo}
                    className="nav_logo_home"
                    alt="img"
                    onClick={(e) => goToProfilePage(e)}
                  />
                </span>
              </li>
            </div>
          </div>
        </div>
        {preInvterviewState === false && postInterviewState === false ? (
          <>
            <Snackbar
              open={cheatAlert}
              autoHideDuration={6000}
              onClose={handleCheatClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert onClose={handleCheatClose} severity="error">
                Violation Detected and Reported
              </Alert>
            </Snackbar>
          </>
        ) : (
          ""
        )}
        {isDataLoaded ? (
          <></>
        ) : (
          <div className="containerfor_circularprogress">
            <CircularProgress />
          </div>
        )}
        {preInvterviewState === false && postInterviewState === false ? (
          <>
            <div className="testHeader_Test">
              <div className="testInfoContainer">
                <span className="testNameHeader">
                  {location.state.test.testName}
                </span>

                <div className="timeleftContainer">
                  <div className="timeLeft">
                    <span>Time Left</span>
                    <span className="timeCount">
                      <span className="timer-calc">
                        {millisToMinutesAndSeconds(questionTimer)}
                      </span>
                    </span>
                  </div>
                </div>

                <div className="progressBarContainer">
                  <Grid container>
                    <Grid size={{ xs: 12 }} sx={stylesSX.absoluteGrid}>
                      <LinearProgress
                        variant="determinate"
                        value={
                          (currentQuestionIndex * 100) / userQuestions.length
                        }
                        maxvalue={0}
                        sx={stylesSX.LinearProgress}
                      />
                      <LinearProgress
                        variant="determinate"
                        id="backProgress"
                        value={
                          ((currentQuestionIndex + 1) * 100) /
                          userQuestions.length
                        }
                        sx={stylesSX.LinearProgress1}
                      />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <Grid
                        container
                        spacing={2}
                        sx={stylesSX.progressGap}
                      >
                        <Grid size={{ xs: 4 }}>
                          <div className="progressLabel_allignment_start">
                            <Typography sx={stylesSX.progrssLabel_ans}>
                              {currentQuestionIndex}
                            </Typography>
                            <Typography sx={stylesSX.progrssLabel_ans}>
                              Answered
                            </Typography>
                          </div>
                        </Grid>
                        <Grid size={{ xs: 4 }}>
                          <div className="progressLabel_allignment_center">
                            <Typography sx={stylesSX.progrssLabel_viewed}>
                              {currentQuestionIndex + 1}
                            </Typography>
                            <Typography sx={stylesSX.progrssLabel_viewed}>
                              Viewed
                            </Typography>
                          </div>
                        </Grid>
                        <Grid size={{ xs: 4 }}>
                          <div className="progressLabel_allignment_end">
                            <Typography sx={stylesSX.progrssLabel_total}>
                              {userQuestions.length}
                            </Typography>
                            <Typography sx={stylesSX.progrssLabel_total}>
                              Total
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
            <div className="videoCam_Drag">
              <Draggable>
                <div className="videoScreen_main">
                  <video
                    style={stylesSX.topVideo}
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                  />
                  <div className="bottomDiv_video">
                    <Videocam />
                    <Mic className="micIcon" />
                  </div>
                </div>
              </Draggable>
            </div>
            <Card sx={stylesSX.testQuestAnsCard}>
              <div className="mainTestContainer">
                <Grid container>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="questionContainer">
                      <Grid container>
                        <Grid size={{ xs: 2 }} container spacing={4}>
                          <div className="questionNoContainer">
                            <span className="questionNo">
                              {currentQuestionIndex + 1}
                            </span>
                          </div>
                        </Grid>
                        <Grid size={{ xs: 10 }}>
                          <div className="questionNameContainer">
                            <span className="questionName" id="testQuestionDescp">
                              {userQuestions.length > 0 ? (
                                <>
                                  {testQuestionDescription(
                                    userQuestions[currentQuestionIndex + 1 - 1]
                                      .questionDesc
                                  )}
                                </>
                              ) : (
                                <p>No questions found</p>
                              )}
                            </span>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }} sx={stylesSX.rightDiv}>
                    <Grid container>
                      <Grid size={{ xs: 12, md: 3 }} ></Grid>
                      <Grid size={{ xs: 12, md: 9 }} >
                        <Grid container>
                          <Grid size={{ xs: 12 }}>
                            <div className="answerHeading">
                              <span>Please select the right answer</span>
                            </div>
                          </Grid>
                          <Grid size={{ xs: 12 }}>
                            {userQuestions[currentQuestionIndex + 1 - 1]
                              ?.questionAnswertype?.code === "SingleChoice"
                              ? userQuestions[currentQuestionIndex + 1 - 1]
                                ? userQuestions[
                                  currentQuestionIndex + 1 - 1
                                ]?.questionAnswer.map((options, i) => (
                                  <div
                                    className="questionoption-alignment_card questionoption "
                                    key={i}
                                  >
                                    <label
                                      className="container_radio_skillTest"
                                      htmlFor={options.id}
                                    >
                                      <div className="block-answer-wrapper">
                                        {options.answerText ? (
                                          options.answerText.split("\n")
                                            .length === 1 ? (
                                            <p className="without-linebreak" dangerouslySetInnerHTML={{
                                              __html: options.answerText
                                            }}></p>
                                          ) : (
                                            options.answerText
                                              .split("\n")
                                              .map((item, idx) => (
                                                <p
                                                  key={idx}
                                                  className="block-answer"
                                                  dangerouslySetInnerHTML={{
                                                    __html: item
                                                  }}
                                                ></p>
                                              ))
                                          )
                                        ) : options.answerText.split("\\n")
                                          .length === 1 ? (
                                          <p className="without-linebreak" dangerouslySetInnerHTML={{
                                            __html: options.answerText
                                          }}>
                                          </p>
                                        ) : (
                                          options.answerText
                                            .split("\\n")
                                            .map((item, idx) => (
                                              <span
                                                key={idx}
                                                className="block-answer"
                                                dangerouslySetInnerHTML={{
                                                  __html: item
                                                }}
                                              ></span>
                                            ))
                                        )}
                                      </div>
                                      <input
                                        type="radio"
                                        name="radio-group"
                                        id={options.id}
                                        checked={
                                          radioButtonChecked === options.id
                                        }
                                        value={options.id}
                                        key={options.id}
                                        onChange={onRadioChange}
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                  </div>
                                ))
                                : null
                              : userQuestions[currentQuestionIndex + 1 - 1]
                                ? userQuestions[
                                  currentQuestionIndex + 1 - 1
                                ].questionAnswer.map((options, i) => (
                                  <form key={i} className="questionoption-alignment_card">
                                    <label
                                      className="container_skillTest"
                                      htmlFor={options.id}
                                    >
                                      <div className="block-answer-wrapper">
                                        {options.answerText ? (
                                          options.answerText.split("\n")
                                            .length === 1 ? (
                                            <p key={i} className="without-linebreak" dangerouslySetInnerHTML={{
                                              __html: options.answerText
                                            }}></p>
                                          ) : (
                                            options.answerText
                                              .split("\n")
                                              .map((item, idx) => (
                                                <p
                                                  key={idx}
                                                  className="block-answer"
                                                  dangerouslySetInnerHTML={{
                                                    __html: item
                                                  }}
                                                >
                                                </p>
                                              ))
                                          )
                                        ) : options.answerText.split("\\n")
                                          .length === 1 ? (
                                          <p className="without-linebreak"
                                            dangerouslySetInnerHTML={{
                                              __html: options.answerText
                                            }}
                                          >
                                          </p>
                                        ) : (
                                          options.answerText
                                            .split("\\n")
                                            .map((item, idx) => (
                                              <span
                                                key={idx}
                                                className="block-answer"
                                                dangerouslySetInnerHTML={{
                                                  __html: item
                                                }}
                                              >
                                              </span>
                                            ))
                                        )}
                                      </div>
                                      <input
                                        type="checkbox"
                                        id={options.id}
                                        key={options.id}
                                        value={options.id}
                                        onClick={(event) =>
                                          handleCheckbox(event, options.id)
                                        }
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                  </form>
                                ))
                                : null}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <div className="nextButtonContainer">
                <div
                  className="bottomContainer_quesCard"
                  id="toggle-question"
                  onClick={(e) => goToNextQuestion(e)}
                >
                  <Typography sx={stylesSX.nextQ}>
                    {currentQuestionIndex + 1 === userQuestions.length
                      ? "End Test"
                      : "Next Question"}
                  </Typography>
                  <img src={NextIcon} alt="img" />
                </div>
              </div>
            </Card>
          </>
        ) : null}
        {preInvterviewState === false && postInterviewState === true ? (
          <>
            {!isreviewSubmited ? (
              <>
                {!isEmailSend ? (
                  <>
                    <Card sx={stylesSX.cardAfterQuestion}>
                      <div className="cardContainer_review">
                        <p className="f-color fs-30 fs-semi-bold mb_16 text-center">
                          Please wait while we submit your test result
                        </p>
                        <div className="containerfor_circularPrg">
                          <CircularProgress />
                        </div>
                      </div>
                    </Card>
                  </>
                ) : (
                  <>
                    <ThankYouContent
                      rating={starRating}
                      setRating={setstarRating}
                      comment={comment}
                      setComment={setComment}
                      handleSubmit={reviewSubmit}
                      isSubmitted={false}
                      showHeader={false}
                    />
                  </>
                )}
              </>
            ) : (
              processAnime === false ?
                <ThankYouContent
                  rating={0}
                  setRating={() => {}}
                  comment=""
                  setComment={() => {}}
                  handleSubmit={() => {}}
                  isSubmitted={true}
                  showHeader={false}
                />
                :
                <Card sx={stylesSX.cardAfterQuestion}>
                  <div className="cardContainer_review">
                    <p className="f-color fs-30 fs-semi-bold mb_16 text-center">
                      Please wait ...
                    </p>
                    <div className="containerfor_circularPrg">
                      <CircularProgress />
                    </div>
                  </div>
                </Card>
            )}
          </>
        ) : null}
        <Dialog
          open={testOnGoingModal}
          onClose={() => setTestOnGoingModal(false)}
          aria-labelledby="customized-dialog-title"
        >
          <DialogContent
            className="removemodal_responsive"
            sx={stylesSX.bodyForRemove}
          >
            <div className="text-center fs-semi-bold f-color fs-18">
              Do you want to stop the test?
            </div>
            <p className="f-color fs-16 fs-semi-bold mt-10">
              Note : Your test result may not be saved.
            </p>
          </DialogContent>
          <DialogActions
            className="responsiveRemove_Modal_button"
            sx={stylesSX.bodyForRemove}
          >
            <div className="remove_modal">
              <button
                type="button"
                className="btn_remove btn-skill cp"
                onClick={() => setTestOnGoingModal(false)}
              >
                No
              </button>
              <button
                type="button"
                className="btn2 btn-green ml_5 cp"
                onClick={() => stopAndGoProfile()}
              >
                Yes
              </button>
            </div>
          </DialogActions>
        </Dialog>
        <NotificationContainer />
      </div>
    </>
  );
};

export default RegisteredStartTest;
